export const comments_5053772 = {"data":{"data":[],"links":{}}}